<template>
  <div>
    <div class="part-title">&diams;<span class="inline-title">资源推荐</span></div>
    <div class="book-list un-tran">
      <div class="book" v-for="(r, index) in tRecords" :key="r.id + index" @click="goTo(r)">
        <div class="des" v-show="r.category === 'bookMetaData'">
          <div class="title-bar">
            <div class="title">{{ r.title }}</div>
            <div class="tag mini">{{ tagInfoRelation[r.category] }}</div>
          </div>
          <div class="des-text">{{ r.summary }}</div>
          <div class="author">作者:{{ r.creator}}</div>
          <div class="keywords">
            <div class="keyword-title">关键词:</div>
            <div class="word" >{{ r.keyword }}</div>
          </div>
        </div>
        <div class="des" v-show="r.category === 'prescriptionIndexData'">
          <div class="title-bar">
            <div class="title">{{ r.chineseMedicinalFormulasName }}</div>
            <div class="tag mini">{{ tagInfoRelation[r.category] }}</div>
          </div>
          <div class="keywords">
            <div class="keyword-title">主治:</div>
            <div class="word">{{ r.indication }}</div>
          </div>
          <div class="keywords">
            <div class="keyword-title">用法:</div>
            <div class="word">{{ r.usage }}</div>
          </div>
        </div>
        <div class="des" v-show="r.category === 'chineseMedicineIndexData'">
          <div class="title-bar">
            <div class="title">{{ r.chineseMedicineName }}</div>
            <div class="tag mini">{{ tagInfoRelation[r.category] }}</div>
          </div>
          <div class="keywords">
            <div class="keyword-title">主治:</div>
            <div class="word">{{ r.indication }}</div>
          </div>
          <div class="keywords">
            <div class="keyword-title">药性:</div>
            <div class="word">{{ r.medicinalProperty }}</div>
          </div>
          <div class="keywords">
            <div class="keyword-title">功效:</div>
            <div class="word">{{ r.functionAndEffect }}</div>
          </div>
          <div class="keywords">
            <div class="keyword-title">产地:</div>
            <div class="word">{{ r.origin}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchApi from '@/api/search.js'
import userActionsApi from '@/api/userActions.js'
import { mapGetters } from 'vuex'
let tagInfoRelation = {
  'bookMetaData': '文献',
  'chartIndexData': '图表',
  'personIndexData': '医家',
  'geographyIndexData': '地理',
  'prescriptionIndexData': '方剂',
  'diseaseNameIndexData': '病名',
  'chineseMedicineIndexData': '中药',
  'meridianIndexData': '经络',
  'acupointsIndexData': '腧穴',
  'organizationIndexData': '机构',
  'eventIndexData': '事件'
}
export default {
  data () {
    return {
      records: [],
      tagInfoRelation
    }
  },
  mounted () {
    this.getData();
  },
  computed: {
    ...mapGetters(['isTra']),
    tRecords () {
      return this.isTra
        ? this.records.map(r => {
            return {
              category: r.category,
              ...JSON.parse(r.originInfos)
            }
          })
        : this.records
    }
  },
  methods: {
    getData () {
      searchApi.selectResouorceHeatData({
        pageSize: 3,
        resourceCategory: 'bookMetaData'
      }).then(response => {
        this.records = [];
        if (response.rows && response.rows.length > 0) {
          let bookIds = '';
          response.rows.forEach(item => {
            let infos = JSON.parse(item.resourceInfos);
            // infos.category = 'bookMetaData';
            // // console.log(infos)
            // this.records.push(infos);

            bookIds = bookIds === '' ? infos.bookId : bookIds + ',' + infos.bookId;
          });

          searchApi.selectByBookIds({
            bookIds
          }).then(res => {
            for (let item of res) {
              item.category = 'bookMetaData';
              this.records.push(item);
            }
          })
        }
      })
    },
    initTagText () {
      this.records.forEach(item => {
        switch (item.category) {
          case 'bookMetaData': {
            item.tagText = '文献';
            break;
          }
        }
      })
    },
    goTo (record) {
      this.addClickRecord(record);
      let url = window.location.origin + window.location.pathname
      this.$bus.$emit('openLogin', {
          url: `${url}#/detail?bookId=${record.bookId}`
      })
    },
    addClickRecord (item) {
      userActionsApi.addUserAction({
        actionCode: 'resourceClick',
        bookId: item.bookId,
        resourceId: item.id,
        resourceInfos: JSON.stringify(item)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.book-list {
  width: 100%;
  overflow-y: auto;
  border-top: 2px solid #7c1823;
  border-bottom: 2px solid #7c1823;
  display: flex;
  flex-direction: column;
  padding-top: 6px;
//   justify-content: space-between;
}
.book {
  width: 100%;
  padding: 0px 20px;
  // border-bottom: 1px solid #a6a6a6;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-top: 15px;
  .cover {
    width: 150px;
    height: 200px;
  }
  .des {
    // height: 190px;
    width: 940px;
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title-bar {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    .tag {
      padding: 4px 10px;
      .font-size-large;
      color: #f5f2eb;
      background-color: #7c1823;
      border-radius: 4px;
      margin-left: 24px;

      &.mini {
        .font-size-tiny;;
        padding: 3px 10px;
      }
    }
    .title {
      color: #4d4030;
      font-weight: bold;
    }
    .des-text {
      color: #7a7374;
      text-indent: 2em;
    }
    .author {
      color: #7a7374;
    }
    .keywords {
      display: flex;
      // align-items: center;
      color: #4d4030;
      margin-bottom: 5px;
      .keyword-title {
        flex-shrink: 0;
      }
      .word {
        margin-left: 18px;
        border-radius: 4px;
        color: #7a7374;
        // overflow:hidden; //超出的文本隐藏
        // text-overflow:ellipsis; //溢出用省略号显示
        // white-space:nowrap; //溢出不换行
        // word-wrap:break-word;
        // word-break:normal;
        white-space: pre-line;
        max-width: 870px;
      }
    }
  }
}

// @media screen and (min-width: 769px) {
  .book-list {
    height: 645px;
  }
  .title {
    .font-size-extra-big;
  }
  .des-text {
    .font-size-medium;
  }
  .keywords {
    .font-size-medium;
  }
// }
// @media screen and (max-width: 768px) {
//   .book-list {
//     height: 755px;
//   }
//   .title {
//     font-size: 32px;
//   }
//   .des-text {
//     .font-size-extra-big;
//   }
//   .keywords {
//     .font-size-extra-big;
//   }
// }
</style>
